export const normalizeApiArray = (value) => {
  if (Array.isArray(value)) {
    return value;
  }

  return [];
};
